// extracted by mini-css-extract-plugin
export default {"avatar":"BaseAvatar_avatar__wl9Jn"};